import { type InsightWrapperVariant } from "./types";

export type NavigationVariant = "light" | "dark";

/**
 * Returns the navigation variant (light or dark) based on the insight type's background color.
 * - Light variant: white progress bar and arrows (for dark backgrounds)
 * - Dark variant: black progress bar and arrows (for light backgrounds)
 */
export function getNavigationVariant(insightType: InsightWrapperVariant): NavigationVariant {
  const darkBackgroundInsights: InsightWrapperVariant[] = [
    "shift-volume",
    "night-shift-legend",
    "top-workplaces",
  ];

  return darkBackgroundInsights.includes(insightType) ? "light" : "dark";
}
